var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"list-button",class:_vm.variant == 'gray' ? 'button-gray' : 'button-primary'},[_c('i',{staticClass:"fa fa-list list-icon",class:_vm.variant == 'gray' ? 'icon-gray' : 'icon-primary'})])
}
var staticRenderFns = []

export { render, staticRenderFns }